module.exports = __webpack_public_path__ + "static/gem-essential-visa-card-0446732e182b83ef3bac15eb10c2f6fb.png";